import { render } from "./DialogCompletaManutenzione.vue?vue&type=template&id=d8e5f226&scoped=true"
import script from "./DialogCompletaManutenzione.vue?vue&type=script&lang=js"
export * from "./DialogCompletaManutenzione.vue?vue&type=script&lang=js"

import "./DialogCompletaManutenzione.vue?vue&type=style&index=0&id=d8e5f226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e5f226"]])

export default __exports__